export const ORDERS = {
    SEARCH_INPUT: "search-input",
    CLEAR_SEARCH: "clear-input",
    COLUMNS_MENU_BTN: "columns-menu-btn",
    EXPORT_MERCHANT_BTN: "export-merchant-btn",
    EXPORT_BTN: "export-btn",
    EXPORT_CSV_BTN: "export-csv",
    EXPORT_FTP_BTN: "export-ftp",
    EXPORT_ORDER_DETAILS: "export-order-details",
    EXPORT_ORDER_SUMMARY: "export-order-summary",
    SORT_BTN: "sort-btn",
    COLUMNS_MENU_LIST: "columns-menu-list",
    PRODUCT_IMAGES: "product-images",
    ORDERS_CURRENCY_CODE: "details-currency",
    ACTIONS: {
        MORE_ACTIONS: "more-actions-icon",
        ICON_EDIT_EZORDER: "icon-edit-ezorder",
        ICON_EDIT: "icon-edit",
        ICON_REORDER: "icon-reorder",
        ACTION_PROGRESS: "action-progress",
        ACTION_REGRESS: "action-regress",
        ACTION_PROGRESS_TO_APPROVED: "action-progress-to_approved",
        ACTION_CANCEL: "action-cancel",
        PAYMENT: "icon-payment",
        ACTION_PDF: "action-pdf",
        DELETE_DRAFT: "action-delete",
        COPY_DRAFT: "action-copy",
        REPLACE_CART_CONTENT: "replace-cart-content",
        DRAFT_TITLE: "title",
        DRAFT_STATUS: "//div[@data-test='status'][text()='Draft']",
        ACTION_SUMMARY: "action-summary",
        ACTION_LINESHEET_PDF: "action-linesheet-pdf",
    },
    BULK_CHECKBOX: "checkbox",
    BULK_ARCHIVE_ORDER: "bulk-action-archive",
    BULK_CANCEL_ORDER: "bulk-action-cancel",
    ARCHIVE_SHIPPED_ORDER: "archive-16",
    ARCHIVE_CANCELLED_ORDER: "archive-17",
    ARCHIVE_PROCESSED_ORDER: "archive-18",
    BULK_ARCHIVE_ALL_ORDERS: "archive-1",
    BULK_CANCEL_ORDERS: "cancel-0",
    ORDER_DETAILS_CONTAINER: "order-details-container",
    ORDER_DELIVERYDATES_BANNER: "details-deliverydates-banner",
    ORDER_DETAILS_LINEITEM: "details-line-item",
    ORDER_LINE_ITEM_TOTALS: "order-line-item-totals",
    ORDER_LINE_ITEM_PRICE: "order-line-item-price",
    ORDER_LINE_TOTAL_UNITS: "order-line-total-units",
    ORDER_LINE_ITEM_TOTAL_AMOUNT: "order-line-item-total-amount",
    ORDER_ROW_STATUS: "status",
    FILTERS: {
        ORDER_STATUS: "filter-status",
        ORDER_STATUS_CHECKBOXES: {
            REVIEW: "checkbox-status-review",
            PENDING: "checkbox-status-pending",
            APPROVED: "checkbox-status-approved",
            PROCESSED: "checkbox-status-processed",
            SHIPPED: "checkbox-status-shipped",
            CANCELLED: "checkbox-status-cancelled",
            DRAFT: "checkbox-status-draft",
            EZ_ORDER: "checkbox-status-ezorder",
        },
        CURRENCY: "filter-currencycode",
        COMPANY_NAME: "companyname",
        COMPANY_FILTER_INPUT: "auto-complete-companyname",
        REP_NAME: "repname",
        SHIPMENT: {
            PENDING: "checkbox-shipmentstatus-none",
            ALL_SHIPPED: "checkbox-shipmentstatus-allshipped",
            PARTIALLY_SHIPPED: "checkbox-partial",
            BACK_ORDERED: "checkbox-shipmentstatus-backorder",
            CANCELLED: "checkbox-shipmentstatus-cancelled",
            NOT_SHIPPED: "checkbox-skip",
        },
    },
    SAVE_FILTERS_TOGGLE: "save-filters",
    ORDER_LINEITEM_PRICE_LABEL: "order-line-item-price-label",
    PAYMENT_MODAL: {
        TERMS: "payment-modal-our-terms",
        SUBMIT: "payment-modal-submit",
        PAY_NOW_PAYMENT_SELECT_CHARGE_NOW: "pay-now-payment-select-charge-now",
        PAYMENT_SELECT_AUTHORIZE: "payment-select-authorize",
        PAYMENT_SELECT_SAVE: "payment-select-save",
        PAYMENT_SELECT_SKIP: "payment-select-skip",
        NO_PERMISSION: "no-permission",
        MOBILE_SUBMIT: "mobile-submit",
        MOBILE_CANCEL: "mobile-cancel",
        MOBILE_DISMISS: "mobile-dismiss",
    },
    REVIEW_CART: "review-cart",
    REPLACE_CART_CONTENT: "replace-cart-content",
    SUBMIT_ORDER: "submitOrder",
    PAYMENT_PROCESSED: "payment-processed",
    PAYMENT_PROCESSED_FOR_ORDERS: "payment-processed-for-orders",
    FORM_ERROR: "form-error",
    BUILD_ORDER: {
        COUNT: "count",
        CONTAINER: "build-order-container",
        ORDER_SETUP_BUTTON: "order-setup-button",
        CALENDAR_BUTTON: "calendar-button",
        SAVE_BUTTON: "save-button",
        CANCEL_BUTTON: "cancel-button",
        ADD_SHIP_DATE_BUTTON: "add-ship-date-button",
        SHIP_DATE_PICKER: "ship-date-picker",
        SHIP_DATE_PICKER_DELETE: "ship-date-picker-delete",
        SHIP_DATE_PICKER_INPUT: "ship-date-picker-input",
    },
    DATE_ORGANIZER: {
        PRODUCT_TITLE: "product-title",
        CHECKBOX: "date-checkbox",
    },
    ORDER_LINE_ITEM_QUANTITY_ROW: "order-line-item-quantity-row",
    ORDER_LINE_ITEM_QUANTITY: "order-line-item-quantity",
    ORDER_LINE_ITEM_SIZE_PRICE: "order-line-item-size-price",
    SHIPMENT_QUANTITY_GROUPS: {
        SHIPPED: "shipment-quantity-groups-shipped",
        BACK_ORDER: "shipment-quantity-groups-back-order",
        CANCELLED: "shipment-quantity-groups-cancelled",
        PENDING: "shipment-quantity-groups-pending",
    },
    CANCELLED_STYLES_LINK_PARENTS: {
        VIEW: "orders-cancelled-styles-link-parent",
        MANAGE: "orders-drop-cancelled-styles-link-parent",
    },
    DROP_STYLES_MODAL: {
        TITLE: "Are you sure?",
        YES_DROP_ALL_BUTTON: "confirm",
        CANCEL: "cancel",
    },
    NOTIFICATION_YES_BUTTON: "[data-test='notification-yes-button']",
    CANCELLED_STYLE_TAG: "button.MuiButtonBase-root MuiIconButton-root cancelled-icon",
    CUSTOMIZATION_REORDER_MODAL: "customization-reorder-modal",
    CUSTOMIZATION_REORDER_CONTENT: "customization-reorder-content",
    CUSTOMIZATION_REORDER_CONFIRM: "customization-reorder-confirm",
    CUSTOMIZATION_REORDER_CANCEL: "customization-reorder-cancel",
    DELETE_CONFIRMATION_MODAL: "delete-confirmation-modal",
    DELETE_CONFIRMATION_LABEL: "delete-confirmation-label",
    REPLACE_CART_CONTENT_MODAL: "replace-cart-content-modal",
    STATUS_ICON: "order-status-icon",
};
